import React from 'react';

const Card = ({ children, title, className = '' }) => {
  return (
    <div className={`bg-white rounded-lg shadow-md p-8 ${className}`}>
      {title && <h2 className="text-xl font-semibold text-gray-900 mb-6">{title}</h2>}
      {children}
    </div>
  );
};

export default Card;
